/* lib/adapters/checkout.js — статические подписи для checkout-экранов.
 * Бэкенд _payment_dict отдаёт только plan_slug/kind (без человекочитаемых меток),
 * поэтому экраны рисуют label по словарю: PLAN_LABELS[plan_slug] / KIND_LABELS[kind].
 * Слаги совпадают с SubscriptionPlan.slug и Payment.KIND_CHOICES. */

const PLAN_LABEL_MAP = {
  // Актуальная линейка (2026).
  demo: 'Демо',
  biz_demo: 'Быстрый старт',
  start: 'Start', expert: 'Expert',
  expert_6m: 'Expert (6 мес.)', expert_12m: 'Expert (12 мес.)',
  expert_1eq2: 'EXPERT 1=2',   // акция октября 2026 (миграция subscriptions.0044)
  biz_s: 'Business S', biz_m: 'Business M', biz_l: 'Business L',
  // Закрытые сетевые тарифы: продаются только именной ссылкой менеджера, но
  // чек и страницы /checkout/{success,fail} клиент видит ровно те же.
  biz_net_s: 'Business Сеть S', biz_net_m: 'Business Сеть M', biz_net_l: 'Business Сеть L',
  // Ретайр-набор — оставлен для исторических платежей.
  free: 'Free', pro: 'Pro', business: 'Business',
};

/* Карта правится руками, и каждый НОВЫЙ тариф рождается в ней отсутствующим —
   консоль продаж заводит тарифы без миграции, и напомнить некому. Экраны
   checkout читают карту НАПРЯМУЮ (`PLAN_LABELS[slug] || slug`), то есть промах
   показывал клиенту сырой слаг «biz_net_m» в строке «Тариф» чека. Поэтому
   фолбэк живёт в самой карте: иначе его пришлось бы повторить в четырёх
   экранах — и он всё равно бы разъехался. Название всё же впишите: «Подписка»
   честно, но бесполезно. */
const UNKNOWN_PLAN_LABEL = 'Подписка';

export const PLAN_LABELS = new Proxy(PLAN_LABEL_MAP, {
  // Подменяем ТОЛЬКО промах по слагу: ключи-не-строки и служебные свойства
  // объекта (toString и пр.) отдаём как есть, иначе сломается всё, что этот
  // объект трогает не как словарь.
  get: (map, key) => ((typeof key !== 'string' || key in map) ? map[key] : UNKNOWN_PLAN_LABEL),
});

export const KIND_LABELS = {
  initial: 'Новая подписка',
  renewal: 'Продление',
  upgrade_proration: 'Доплата при апгрейде',
  upgrade: 'Доплата при апгрейде',
};
